import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Redirect} from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import ReCaptcha from 'react-google-recaptcha'
import {Input, Button} from 'antd'

import style from './freetrial.sass'

@inject('store') @observer
class FreeTrial extends Component {
  componentDidMount() {
    this.props.store.signup.resetComplete()
  }
  handleChange = (e) => {
    const {name, value} = e.target
    this.props.store.signup.setCredentials(name, value)
  }
  handleBlur = (e) => {
    this.props.store.signup.validateField(e.target.name, true)
  }
  handleFocus = (e) => {
    this.props.store.signup.removeError(e.target.name)
  }
  handleSubmit = () => {
    this.props.store.signup.freeTrialRequest()
  }
  handleRecaptcha = (value) => {
    this.props.store.signup.setCredentials('recaptcha_response', value)
  }
  render() {
    const {credentials, errors, loading, trialRequestComplete} = this.props.store.signup
    const captchaComplete = !!credentials.recaptcha_response
    if (trialRequestComplete) {
      return <Redirect to='/signup-complete'/>
    }
    return(
      <div>
        <DocumentTitle title='Free Trial'/>
        <div styleName='banner'/>
        <section className='bg-white'>
          <div className='landing-container' styleName='container'>
            <h3>Free Trial</h3>
            <p>
              Find out how your insights and instincts combined with the most innovative AI can build market beating strategies.
            </p>
            <h5>
              Algoriz offers a one month trial to professional traders and trading institutions. To receive a trial and information
              on pricing, please enter your corporate contact information below.
            </h5>
            <form styleName='form'>
              <div styleName='field'>
                <label htmlFor='first_name'>First Name <span>*</span></label>
                <Input
                  size='large'
                  type='text'
                  name='first_name'
                  value={credentials.first_name}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  onFocus={this.handleFocus}
                  styleName={errors.first_name ? 'has-error' : ''}
                />
                <p styleName='error'>{errors.first_name}</p>
              </div>
              <div styleName='field'>
                <label htmlFor='last_name'>Last Name <span>*</span></label>
                <Input
                  size='large'
                  type='text'
                  name='last_name'
                  value={credentials.last_name}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  onFocus={this.handleFocus}
                  styleName={errors.last_name ? 'has-error' : ''}
                />
                <p styleName='error'>{errors.last_name}</p>
              </div>
              <div styleName='field'>
                <label htmlFor='company'>Company <span>*</span></label>
                <Input
                  size='large'
                  type='text'
                  name='company'
                  value={credentials.company}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  onFocus={this.handleFocus}
                  styleName={errors.first_name ? 'has-error' : ''}
                />
                <p styleName='error'>{errors.company}</p>
              </div>
              <div styleName='field'>
                <label htmlFor='number_of_trades'>Number of Traders <span>*</span></label>
                <Input
                  size='large'
                  type='text'
                  name='number_of_traders'
                  value={credentials.number_of_traders}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  onFocus={this.handleFocus}
                  styleName={errors.number_of_traders ? 'has-error' : ''}
                />
                <p styleName='error'>{errors.number_of_traders}</p>
              </div>
              <div styleName='field'>
                <label htmlFor='business_email'>Business Email <span>*</span></label>
                <Input
                  size='large'
                  type='email'
                  name='business_email'
                  value={credentials.business_email}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  onFocus={this.handleFocus}
                  styleName={errors.business_email ? 'has-error' : ''}
                />
                <p styleName='error'>{errors.business_email}</p>
              </div>
              <div styleName='field'>
                <label htmlFor='phone'>Phone <span>*</span></label>
                <Input
                  size='large'
                  type='text'
                  name='phone'
                  value={credentials.phone}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  onFocus={this.handleFocus}
                  styleName={errors.phone ? 'has-error' : ''}
                />
                <p styleName='error'>{errors.phone}</p>
              </div>
              <div styleName='field'>
                <label htmlFor='country'>Country <span>*</span></label>
                <Input
                  size='large'
                  type='text'
                  name='country'
                  value={credentials.country}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  onFocus={this.handleFocus}
                  styleName={errors.country ? 'has-error' : ''}
                />
                <p styleName='error'>{errors.country}</p>
              </div>
              <div styleName='field'>
                <label htmlFor='state'>State <span>*</span></label>
                <Input
                  size='large'
                  type='text'
                  name='state'
                  value={credentials.state}
                  onChange={this.handleChange}
                  onBlur={this.handleBlur}
                  onFocus={this.handleFocus}
                  styleName={errors.state ? 'has-error' : ''}
                />
                <p styleName='error'>{errors.state}</p>
              </div>
              <div styleName='field'>
                <ReCaptcha
                  sitekey='6LeZ7T0UAAAAANszyCDgGufTqBUHqXp6kKYcVtjf'
                  onChange={this.handleRecaptcha}
                />
              </div>
              <div styleName='field'>
                <Button type='primary' loading={loading} size='large' onClick={this.handleSubmit} disabled={!captchaComplete}>
                  Start My Free Trial
                </Button>
              </div>
            </form>
          </div>
        </section>
      </div>
    )
  }
}

export default FreeTrial
